export default function (app) {
    app.directive('ktsAuthorizePurchase', function () {
        return {
            template: require('./authorizepurchase.html'),
            controller: ['$scope', 'Restangular', '$state', function Controller($scope, Restangular, $state) {
                    console.log($scope.purchase);
                    $scope.authorize = function () {
                        var r = confirm("Are you sure you want to authorize?");
                        if (r === true) {
                            Restangular.one('purchases/purchase/confirm/' + $scope.purchase.id).get().then(function () {
                                $state.reload();
                            });
                        }
                    };
                }],
            scope: {
                purchase: '='
            }
        };
    });

}





// WEBPACK FOOTER //
// ./js/actions/authorizepurchase.js